<template>
  <div class="timesheet-section">
    <hr v-if="layoutData.divider" style="border-top-color: #ddd; margin: 8px 0">
    <timesheet-group-basic v-if="fieldType == 'group' || fieldType == 'root'" :layout="layoutData" @change="onChange" />
    <timesheet-group-material v-else-if="fieldType == 'material'" :layout="layoutData" @change="onChange" />
    <timesheet-group-activity v-else-if="fieldType == 'activity'" :layout="layoutData" @change="onChange" />
    <timesheet-group-collapsible v-else-if="fieldType == 'collapsible_group'" :layout="layoutData" @change="onChange" />
    <timesheet-group-tabs v-else-if="fieldType == 'tabs'" :layout="layoutData" @change="onChange" />
    <timesheet-group-field-selector v-else-if="fieldType == 'field_selector'" :layout="layoutData" @change="onChange" />
    <div v-else>
      <timesheet-field :layout="layoutData" @change="onChange" :errors="layoutData.errors" :value="layoutData.value" />
    </div>
  </div>
</template>

<script>
  import TimesheetField from './field/TimesheetField.vue'
  import TimesheetGroupActivity from './group/TimesheetGroupActivity.vue';
  import TimesheetGroupBasic from './group/TimesheetGroupBasic.vue';
  import TimesheetGroupCollapsible from './group/TimesheetGroupCollapsible.vue';
  import TimesheetGroupFieldSelector from './group/TimesheetGroupFieldSelector.vue';
  import TimesheetGroupMaterial from './group/TimesheetGroupMaterial.vue';
  import TimesheetGroupTabs from './group/TimesheetGroupTabs.vue';

  export default {
    name: "timesheet-fieldset",
    components: { 
      TimesheetField, 
      TimesheetGroupTabs, 
      TimesheetGroupFieldSelector,
      TimesheetGroupCollapsible,
      TimesheetGroupActivity,
      TimesheetGroupBasic,
      TimesheetGroupMaterial
    },
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type;
      }
    },
    methods: {
      onChange(e,l,v,i) {
        this.$emit("change", e, l, v, i);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>